<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit
          :form="saleInvoice"
          :contacts="contacts"
          :accounts="accounts"
          :accountNumber="accountNumber"
          ref="formEdit"
          v-if="!edit"
        ></form-edit>
        <detail :id="id" :form="saleInvoice" :contacts="contacts" v-if="edit"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('sale-invoice.update')"
                  color="success"
                  v-on="on"
                  @click="updateItem"
                >
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('sale-invoice.print')"
                  color="success"
                  v-on="on"
                  @click="printJournal"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Journal</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <!-- <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-if="$rbac.can('sale-invoice.print')" color="warning" v-on="on" @click="routeToPrintPreview">
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Print Preview</span>
            </v-tooltip>
          </v-col>
        </v-row> -->
        <v-row class="py-0 mb-2" v-if="edit && !saleInvoice.fp">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="previewPajak">
                  <v-icon>
                    mdi-download
                  </v-icon>
                </v-btn>
              </template>
              <span>Export Pajak</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="openTaxSale">
                  <v-icon>
                    mdi-bank
                  </v-icon>
                </v-btn>
              </template>
              <span>Tax Serial Number</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row
          class="py-0 mb-2"
          v-if="edit && saleInvoice.status === 'Outstanding' && !saleInvoice.hidden"
        >
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="$rbac.can('sale-invoice.update')"
                  color="success"
                  v-on="on"
                  @click="editItem"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <!-- <v-row class="py-0 mb-2" v-if="edit && saleInvoice.status === 'Outstanding'">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-if="$rbac.can('sale-invoice.delete')" color="error" v-on="on" @click.stop="deleteDialog">
                  <v-icon>
                    mdi-cancel
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row> -->
        <v-row class="py-0 mb-2" v-if="!edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2" v-if="edit">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>
                    mdi-history
                  </v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-cancel
      :dialog="dialog"
      :invoiceNumber="saleInvoice.invoiceNumber"
      @cancel="cancelInvoice('')"
      @cancelInvoice="cancelInvoice('invoice')"
      @close="close"
    ></dialog-cancel>
    <dialog-remark
      :dialog="dialogRemark"
      :form="formRemark"
      @save="updateRemark"
      @close="close"
    ></dialog-remark>
    <preview-faktur-pajak
      :dialog="pajak"
      :item="saleInvoice"
      ref="pajak"
      @close="close"
      @export="exportPajak"
    ></preview-faktur-pajak>

    <dialog-sale-tax
      :dialog="dialogSaleTax"
      :form="saleInvoice"
      @save="saveSalesTax"
      @close="close"
    ></dialog-sale-tax>

    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="SaleInvoice"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailSaleInvoice";
import FormEdit from "./FormSaleInvoice";
import DialogCancel from "@/components/DialogCancel";
import { mapState } from "vuex";
import fileDownload from "js-file-download";
import DialogRemark from "@/components/DialogRemark";
import PreviewFakturPajak from "../PreviewFakturPajak.vue";
import DialogSaleTax from "../../../components/DialogSaleTax.vue";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "sale-invoice-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-cancel": DialogCancel,
    DialogRemark,
    PreviewFakturPajak,
    DialogSaleTax,
    DialogAuditHistory,
  },
  props: {
    id: {
      type: Number,
      default: () => undefined,
    },
  },
  data: () => ({
    edit: true,
    dialog: false,
    pajak: false,
    dialogRemark: false,
    dialogSaleTax: false,
    dialogAuditHistory: false,
    accounts: [],
    saleInvoice: {},
    formRemark: {},
    accountNumber: "",
  }),
  computed: {
    ...mapState("external", ["customers", "contacts"]),
    ...mapState("saleInvice", ["lastPercentage"]),
  },
  methods: {
    async getSaleInvoice() {
      const response = await this.$store.dispatch("saleInvoice/getById", this.id);
      if (response.status === 200) {
        this.saleInvoice = response.data;
        this.$store.dispatch("external/getContact", response.data.customerId);
        this.getAR(response.data.customerId);
      }
    },
    async getAccounts() {
      const response = await this.$store.dispatch("chartOfAccount/getAccounts");
      if (response.status === 200) {
        this.accounts = response.data;
      }
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.checkJournal();
    },
    previewPajak() {
      this.pajak = true;
      this.$refs.pajak.createPdf();
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogRemark = false;
      this.pajak = false;
      this.dialogSaleTax = false;
    },
    cancel() {
      this.getSaleInvoice();
      this.edit = true;
    },
    routeToPrintPreview() {
      this.$router.push({ name: "Print Preview Sale Invoice", params: { id: this.id } });
    },
    printJournal() {
      this.$router.push({ name: "Journal Sale Invoice", params: { id: this.id } });
    },
    async updateRemark(item) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleInvoice/updateRemark", item)
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    openRemark() {
      this.dialogRemark = true;
    },
    async exportPajak() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/exportPajak", { id: this.id, type: "Invoice" })
        .then(response => {
          this.$store.commit("SET_LOADER", false);
          fileDownload(
            response.data,
            "ExportPajakInvoice-" + this.saleInvoice.invoiceNumber + ".csv"
          );
        })
        .catch(() => {
          this.$store.commit("SET_LOADER", false);
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
        });
    },
    async cancelInvoice(type) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleInvoice/cancelInvoice", { id: this.id, type: type })
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.commit("SET_LOADER", false);
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
        });
    },
    async getAR(id) {
      await this.$store
        .dispatch("chartOfAccount/getAR", id)
        .then(response => (this.accountNumber = response.data));
    },
    async saveSalesTax(form) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("saleInvoice/saveTaxSale", form)
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    openTaxSale() {
      this.dialogSaleTax = true;
    },
    getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([this.getAccounts(), this.getSaleInvoice()])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.commit("SET_LOADER", false);
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
        });
    },
  },
  mounted() {
    this.getInitialData();
  },
  beforeMount() {
    this.formRemark = {
      remark: "",
      type: "Invoice",
      transactionId: this.id,
    };
  },
};
</script>

<style></style>
